import type {CustomCssVarsFnParams} from '@wix/wixstores-client-storefront-common';

/* istanbul ignore file */
export const footerDescriptionCustomCssVars = ({styleParams: styles}: CustomCssVarsFnParams) => {
  return {
    footerDescriptionTopPadding: `${styles.numbers.gallery_categoryFooterDescriptionTopPadding}px`,
    footerDescriptionBottomPadding: `${styles.numbers.gallery_categoryFooterDescriptionBottomPadding}px`,
    footerDescriptionSidesPadding: `${styles.numbers.gallery_categoryFooterDescriptionSidesPadding}px`,
    footerDescriptionBackgroundColor: styles.colors.gallery_categoryFooterDescriptionBackgroundColor,
    footerDescriptionBorderRadius: `${styles.numbers.gallery_categoryFooterDescriptionBorderRadius}px`,
    footerDescriptionBorderColor: styles.colors.gallery_categoryFooterDescriptionBorderColor,
    footerDescriptionBorderWeight: `${styles.numbers.gallery_categoryFooterDescriptionBorderWeight}px`,
  };
};
